<template>
  <div>
    <HijackedUserAlert />
    <router-view class="user-app" />
  </div>
</template>

<script>
import { beforeRouteEnter } from "@/router/utils";
import HijackedUserAlert from "@/features/hijack/HijackedUserAlert.vue";

export default {
  components: { HijackedUserAlert },
  beforeRouteEnter,
};
</script>

<style lang="scss">
@import "../assets/scss/site";
@import "../assets/css/fontawesome-all.min.css";
</style>
